import React, { Component } from 'react';
import { Field, reduxForm, change } from 'redux-form';
import { Grid, Header, Button } from 'semantic-ui-react';
import { Dropzone } from 'Components/forms/Dropzone';
import { renderField } from './FormHelper';
import { FileFieldEnum } from './FieldEnum';
import { FILE_CONFIGURATIONS_FORM_NAME } from './FormEnum';

class FileConfigurations extends Component {
  delimiterButtons = [
    { title: 'Comma', delimiter: ',' },
    { title: 'Tab', delimiter: decodeURIComponent('\t') },
    { title: 'Pipe', delimiter: '|' },
  ];

  filePreview = e => {
    this.props.clearImportStudentsErrors();
    if (e.target.files[0] === undefined || e.target.files[0] === 0) {
      this.props.setImportStudentsErrors('Please choose a file.');
      return;
    }
    this.props.handleFilePreview(e.target.files[0]);
  };

  onDrop = files => {
    this.props.clearImportStudentsErrors();
    if (files[0] === undefined || files[0] === 0) {
      this.props.setImportStudentsErrors('Please choose a file.');
      return;
    }
    this.props.handleFilePreview(files[0]);
  };

  changeDelimiter = delimiter => {
    const { dispatch, changeDelimiter } = this.props;

    dispatch(
      change(
        FILE_CONFIGURATIONS_FORM_NAME,
        FileFieldEnum.FileSeparatorRadio,
        delimiter
      )
    );
    changeDelimiter(delimiter);
  };

  render() {
    const { displayDropZone, formValues } = this.props;

    return (
      <div>
        <form>
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <legend>
                  <Header
                    content="File Configuration Settings"
                    color="orange"
                  />
                </legend>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row className="row--compressed" columns={2}>
              <Grid.Column>
                <label className="d-block">File Format:</label>
                <Button.Group basic className="btn-group--active-group">
                  {this.delimiterButtons.map(button => (
                    <Button
                      key={button.title}
                      basic
                      className="white"
                      active={
                        formValues.fileSeparatorRadio === button.delimiter
                      }
                      onClick={e => {
                        e.preventDefault();
                        this.changeDelimiter(button.delimiter);
                      }}
                    >
                      {button.title}
                    </Button>
                  ))}
                </Button.Group>
                <Field
                  name={FileFieldEnum.FileSeparatorRadio}
                  component={renderField}
                  label={false}
                  props={{ type: 'hidden' }}
                />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <div>
                  <label>Select CSV file</label>
                  {displayDropZone && (
                    <Dropzone
                      accept=".csv,.txt"
                      activeClassName="file--dropzone--active"
                      className="file--dropzone"
                      multiple={false}
                      name={FileFieldEnum.FileName}
                      onDrop={this.onDrop}
                    >
                      <p>
                        Drag and drop the csv file here <br />
                        <small>or double click to select file</small>.
                      </p>
                    </Dropzone>
                  )}
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </form>
      </div>
    );
  }
}

export default reduxForm({
  destroyOnUnmount: false,
  enableReinitialize: true,
  form: FILE_CONFIGURATIONS_FORM_NAME,
})(FileConfigurations);



// WEBPACK FOOTER //
// ./src/common/FileConfigurations.js